<template>
  <div>
    <!-- <HeaderNavbar /> -->
    <el-row>
      <HeaderNavbar :activeIndex="'12'" />
    </el-row>

    <!-- 联系我们 -->
    <el-row class="bghover" style="height: 330px">
      <el-col :sm="14" style="height: 300px">
        <el-image
          style="padding: 50px 20px 50px 20px; height: 230px; float: right"
          :src="contactuspositionIMG"
        ></el-image>
      </el-col>

      <el-col :sm="10">
        <div class="intro-content">
          <div class="contact-info">
            <h3 class="textAlignLeft">联系我们</h3>
            <ul>
              <li>地 址: 北京市海淀区北京大学理科5号楼</li>
              <li>邮 编: 100871</li>
              <li>联系电话：+86 10-6276-0736</li>
              <li>邮 箱：pm_group@163.com</li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 报告成员 -->
    <el-row>
      <div class="member-info bggrey bghover">
        <h2>《空气质量评估报告（十）》课题组成员</h2>
        <div class="flex-box">
          <div
            class="single-card"
            v-for="peop in report7People"
            :key="peop.name"
          >
            <div>
              <el-image
                style="width: 70px; height: 90px"
                :src="peop.img"
                fit="scale-down"
              ></el-image>
            </div>

            <div class="report-people-intro">
              <div>{{ peop.name }}</div>
              <div>{{ peop.acad }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <!-- 网络建设 -->
    <el-row>
      <div class="member-info bghover">
        <h3>网站建设主要成员</h3>
        <div class="flex-box">
          <div
            class="single-card"
            v-for="peop in peopleContent"
            :key="peop.name"
          >
            <div>
              <el-image
                style="width: 200px; height: 200px"
                :src="peop.img"
                fit="scale-down"
              ></el-image>
            </div>

            <div class="report-people-intro">
              <div>{{ peop.name }}</div>
              <div>{{ peop.acad }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-row>

    <el-row>
      <HFooter />
    </el-row>
  </div>
</template>
<style scoped>
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
}
.intro-content {
  padding: 30px;
  text-align: justify;
  text-indent: 2em;
  line-height: 1.8em;
}
.intro-img {
  padding: 30px;
  max-height: 300px;
  overflow: hidden;
}

.contact-info ul {
  padding: 0;
}
.contact-info ul li {
  text-align: left;
  list-style: none;
  line-height: 24px;
  font-size: 14px;
}

.flex-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  max-width: 1200px;
  margin: 0 auto;
}

.single-card {
  padding: 20px 0;
  align-self: center;
  width: 22%;
  min-width: 280px;
  text-align: center;
}

/* 成员部分 */
.member {
  max-width: 1440px;
  padding: 20px;
  margin: auto;
}

.member-info {
  flex: 1;
}

.member-info h2 {
  margin: 0;
  padding: 20px 20px;
}

.report-member-info {
  flex: 2;
  min-width: 520px;
  text-align: left;
  /* padding-left: 0 20px; */
  padding: 0 20px;
}

.report-member-info h2 {
  text-align: center;
  margin-bottom: 45px;
}
.report-single-card {
  margin-top: 10px;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}
.report-single-card:hover {
  border-bottom: 1px solid rgba(255, 145, 0, 0.5);
}

.report-people-intro {
  margin-top: 2px;
  margin-left: 5px;
  font-size: 12px;
}
</style>
<script>
// @ is an alias to /src
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import HFooter from "@/components/HFooter.vue";
import {
  initBaiduMapCharts,
  drawBaiduMapCityBoundary,
  addCityMarker2BaiduMap,
} from "@/assets/js/utils-map.js";
export default {
  // name: "Home",
  data() {
    return {
      contactuspositionIMG: require("@/assets/contactus-position.png"),
      report7People: [
        {
          name: "罗山杉",
          img: require("@/assets/people/report10/luoshanshan.jpg"),
          acad: "北京大学前沿交叉学科研究院硕士研究生",
        },

        {
          name: "陈涵玥",
          img: require("@/assets/people/report10/chenhanyue.png"),
          acad: "北京大学统计科学中心博士研究生",
        },

        {
          name: "王   佳",
          img: require("@/assets/people/report10/wangjia.jpg"),
          acad: "江西财经大学统计学院博士研究生",
        },

        {
          name: "詹皓翔",
          img: require("@/assets/people/report10/zhanhaoxiang.png"),
          acad: "北京大学数学科学学院本科生",
        },

        {
          name: "林鸿斌",
          img: require("@/assets/people/report10/linhongbing.png"),
          acad: "北京大学数学科学学院本科生",
        },

        {
          name: "刘   俊",
          img: require("@/assets/people/report10/liujun.png"),
          acad: "江西财经大学统计学院博士研究生",
        },

        {
          name: "丁嘉麟",
          img: require("@/assets/people/report10/dingjialin.jpg"),
          acad: "北京大学数学科学学院本科生",
        },

        {
          name: "王昺皓",
          img: require("@/assets/people/report10/wangruihao.jpg"),
          acad: "北京大学前沿交叉学科研究院硕士研究生",
        },

        {
          name: "闫   夏",
          img: require("@/assets/people/report10/yanxia.jpg"),
          acad: "北京大学前沿交叉学科研究院硕士研究生",
        },

        {
          name: "戴华凝",
          img: require("@/assets/people/report10/daihuaning.jpg"),
          acad: "北京市十一学校学生",
        },

        {
          name: "孙浩轩",
          img: require("@/assets/people/report10/sunhaoxuan.jpg"),
          acad: "北京大学前沿交叉学科研究院博士研究生",
        },

        {
          name: "郭   斌",
          img: require("@/assets/people/report10/guobing.jpg"),
          acad: "西南财经大学统计研究中心、统计学院副教授",
        },
        {
          name: "陈松蹊",
          img: require("@/assets/people/report10/chensongxi.png"),
          acad: "北京大学统计科学中心、数学科学学院、光华管理学院讲席教授, 课题负责人",
        },
      ],
      peopleContent: [
        {
          name: "陈 力",
          cont: "网站建设",
          acad: "北京大学前沿交叉学科研究院硕士研究生",
          img: require("@/assets/people/chenli.jpg"),
        },
        {
          name: "孙浩轩",
          cont: "报告七成员",
          acad: "北京大学前沿交叉学科研究院博士研究生",
          img: require("@/assets/people/sunhaoxuan.jpg"),
        },
        {
          name: "游 威",
          cont: "报告七成员",
          acad: "北京大学光华管理学院本科生",
          img: require("@/assets/people/youwei.jpg"),
        },
        {
          name: "罗山杉",
          cont: "报告七成员",
          acad: "北京大学前沿交叉学科研究院硕士研究生",
          img: require("@/assets/people/luoshanshan.jpg"),
        },
      ],
    };
  },
  components: {
    HeaderNavbar,
    HFooter,
  },
  created() {},
  mounted() {
    // this.map = initBaiduMapCharts(
    //   "contact-map-chart",
    //   true,
    //   [116.31563844629878, 39.998541755587034],
    //   15
    // );
    // var marker = new BMap.Marker(
    //   new BMap.Point(116.31563844629878, 39.998541755587034)
    // );
    // // 在地图上添加点标记
    // this.map.addOverlay(marker);
  },
};
</script>
